import React from 'react';
import { Container, Settings, Row, Item } from './styled';
import type { FlowDefinition } from '../../types';

interface Props {
  description: FlowDefinition;
}

const PairingMap: Record<string, string> = {
  first_first: 'First Initial Event',
  last_first: 'Last Initial Event',
};

const FlowMetadata: React.FC<Props> = ({ description }) => {
  return (
    <Container>
      <Settings>
        <Row>
          <Item>
            <div className="label">Distribution:</div>
            <div className="value">
              {description?.settings?.distribution?.min ?? 'N/A'} -{' '}
              {description?.settings?.distribution?.max ?? 'N/A'}
              <span>{description?.settings?.timeout_unit ?? '--'}</span>
            </div>
          </Item>
          <Item>
            <div className="label">Pairing:</div>
            <div className="value">
              {PairingMap[description?.pairing_logic] || description?.pairing_logic}
            </div>
          </Item>
        </Row>
      </Settings>
    </Container>
  );
};

export default FlowMetadata;
